import { useLoader } from "../context/LoaderContext";
import { useSettings } from "../context/SettingsContext";

const Loader = () => {
  const { loading } = useLoader();
  const { generalSettings } = useSettings();

  return (
    <>
      {loading && (
        <div className="preloader">
          {generalSettings?.documentUrl ? (
            <img
              className="preloader__image"
              src={`${process.env.REACT_APP_Url}/${generalSettings?.documentUrl}`}
              alt="loader-logo"
            />
          ) : (
            <div className="spinner"></div>
          )}
        </div>
      )}
    </>
  );
};

export default Loader;
